// extracted by mini-css-extract-plugin
export default {"wrap":"d4bc99847cfe"};